namespace SorAraBul.Administration {
    export interface PurchasePackageFeaturesRow {
        Id?: number;
        PurchasePackageId?: number;
        PurchasePackageName?: string;
        FeatureText?: string;
        SortOrder?: number;
        IsActive?: number;
        InsertDate?: string;
        InsertUserId?: number;
        UpdateDate?: string;
        UpdateUserId?: number;
    }

    export namespace PurchasePackageFeaturesRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'FeatureText';
        export const localTextPrefix = 'Administration.PurchasePackageFeatures';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'Administration:SuperAdmin';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            PurchasePackageId = "PurchasePackageId",
            PurchasePackageName = "PurchasePackageName",
            FeatureText = "FeatureText",
            SortOrder = "SortOrder",
            IsActive = "IsActive",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            UpdateDate = "UpdateDate",
            UpdateUserId = "UpdateUserId"
        }
    }
}
